import styled, { css } from 'styled-components'
import { ReactComponent as CollapseIcon } from 'assets/img/collapse-arrow-icon.svg'
import { Icon } from '@material-ui/core'
import { GRAY6, GRAY_RGB, LIGHT_RED2, RED2 } from 'constants/colors'

export const CollapseIconWrapper = styled(CollapseIcon)<{ isOpened: boolean }>`
  margin: 0;
  transition: 0.3s;
  ${({ isOpened }) =>
    isOpened &&
    css`
      transform: rotateZ(90deg);
    `}
`

export const MoreOptionsIcon = styled(Icon)<{ isMenuDisabled?: boolean }>`
  display: flex;
  align-items: center;
  transition: 0.3s;
  border-radius: 4px;
  cursor: pointer;

  ${({ isMenuDisabled }) =>
    isMenuDisabled &&
    css`
      cursor: default;
      opacity: 0.5;
    `}

  &:hover {
    background: rgba(${GRAY_RGB} 0.1);
  }
`
export const GroupName = styled.span`
  font-weight: 700;
`

export const JobPlaceholder = styled.div`
  height: 46px;
  background: ${GRAY6};
  margin-bottom: 8px;
`

export const TaskList = styled.div`
  position: relative;
  padding: 0 0 2px 20px;

  &:before {
    position: absolute;
    content: '';
    top: 0;
    bottom: 30px;
    left: 0;
    width: 2px;
    background: ${GRAY6};
  }
`

export const OverdueLabel = styled.div`
  padding: 2px 8px;
  background: ${LIGHT_RED2};
  color: ${RED2};
  text-transform: capitalize;
  font-weight: normal;
  border-radius: 16px;
  font-size: 12px;
  line-height: 18px;
  margin-right: 8px;
`

export const JobsWrapper = styled.div`
  &:nth-child(2) {
    > div {
      border-radius: 8px 8px 0 0;
    }
  }

  &:last-child {
    > div {
      border-radius: 0 0 8px 8px;
    }
  }
`
